// Box/bag numbering shared by the Get Labels tabs: A0001…A9999, B0001…
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function formatLabelNumber(n) {
  const idx = Math.floor((n - 1) / 9999);
  const num = ((n - 1) % 9999) + 1;
  return `${LETTERS[idx] || 'Z'}${String(num).padStart(4, '0')}`;
}

// Accepts what people read off a label: "A0123", "a123", "123", "BOX#A0123",
// "BAG # A0123". Returns the counter value or null.
export function parseLabelNumber(text) {
  const m = String(text ?? '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .replace(/^(BOX|BAG)/, '')
    .match(/^([A-Z])?(\d{1,4})$/);
  if (!m) return null;
  const num = Number(m[2]);
  if (num < 1) return null;
  return (m[1] ? LETTERS.indexOf(m[1]) : 0) * 9999 + num;
}
